import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
export default function CardSection(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('jmtd-card-section', className, {})
  }, children);
}
CardSection.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
CardSection.defaultProps = {
  className: '',
  children: null
};